import { Outlet, RouteObject } from "react-router-dom";
import { lazy } from "react";
import BackgroundLayoutWithLogo from "ui/common/components/layout/BackgroundLayoutWithLogo/BackgroundLayoutWithLogo";

export enum PaymentGatewayRoutes {
    MAIN = "/payment-gateway/:address/:tokenAddress",
}

const PaymentGatewayPage = lazy(() => import("../pages/PaymentGatewayPage"));

export const usePaymentGatewayRoutes = (): RouteObject[] => {
    return [
        {
            path: PaymentGatewayRoutes.MAIN,
            element: (
                <BackgroundLayoutWithLogo>
                    <Outlet />
                </BackgroundLayoutWithLogo>
            ),
            children: [{ path: PaymentGatewayRoutes.MAIN, element: <PaymentGatewayPage /> }],
        },
    ];
};
